import { Skeleton } from '@/comp/skeleton/Skeleton';
import './formSkeleton.scss';

export const SkeletonView = () => (
    <div className="form-skeleton lazy-load-background">
        <div className="content-wrapper ">
            <Skeleton className={'headline'} />
            <Skeleton className={'content'} />
        </div>
        <section>
            {Array.from({ length: 3 }).map((_, index) => (
                <article key={index}>
                    <div className="container">
                        <Skeleton className={'sub-headline'} />
                        <Skeleton className={'sub-content'} />
                    </div>
                </article>
            ))}
        </section>
        <section>
            <div className="container flex flex-between flex-row">
                <Skeleton width={'15%'} height={'40px'} className={'loading-button'} />
                <Skeleton width={'15%'} height={'40px'} className={'loading-button'} />
            </div>
        </section>
    </div>
);
export default SkeletonView;
